import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';

const SubmitNextUpReviewPageConfirmationModalWithActionItemsOverride = buildFacetDesignOverride();

export default SubmitNextUpReviewPageConfirmationModalWithActionItemsOverride;
